import React, { useState, useRef } from "react";
import ComposePage from "../../pages/ComposePage";
import "./ComposeModal.css";

export default function ComposeModal({
  open,
  onClose,
  style,
  composeTo,
  compose,
  authHeaders,
  signatureList,
  defaultSignatureId,
  onMailSent,
  setToast,
  isMobile,
  ...props
}) {
  const [position, setPosition] = useState({ x: 20, y: 20 });
  const [isDragging, setIsDragging] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);   // ✅ ADD
  const [isMaximized, setIsMaximized] = useState(false);   // ✅ ADD

  const dragRef = useRef(null);


  // Pass composeTo to ComposePage if present
  if (!open) return null;

  const handleMouseDown = (e) => {
    setIsDragging(true);
    dragRef.current = {
      offsetX: e.clientX - position.x,
      offsetY: e.clientY - position.y,
    };
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - dragRef.current.offsetX,
      y: e.clientY - dragRef.current.offsetY,
    });
  };

  const handleMouseUp = () => setIsDragging(false);

  return (
    <div
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <div
        className={`compose-modal 
          ${isMinimized ? "minimized" : ""} 
          ${isMaximized ? "maximized" : ""}`}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          ...style
        }}
      >
        {/* HEADER */}
       <div
  className="compose-header"
  onMouseDown={(e) => {
    // prevent drag when clicking buttons
    if (e.target.closest(".compose-actions")) return;

    handleMouseDown(e);
  }}
>
          <span>✍️ New Email</span>
        <div className="compose-actions">
  <button
    onClick={(e) => {
      e.stopPropagation();
      setIsMinimized(!isMinimized);
    }}
  >
    —
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();
      setIsMaximized(!isMaximized);
    }}
  >
    ⬜
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();
      onClose();
    }}
  >
    ✕
  </button>
</div>
        </div>
        {/* BODY */}
        {!isMinimized && (
          <div className="compose-body">
            <ComposePage
              {...props}
              compose={compose}
              authHeaders={authHeaders}
              signatureList={signatureList}
              defaultSignatureId={defaultSignatureId}
              onMailSent={onMailSent}
              setToast={setToast}
              isMobile={isMobile}
              composeTo={composeTo}
            />
          </div>
        )}
        {/* RESIZE */}
        <div
          className="resize-handle"
          onMouseDown={(e) => {
            e.preventDefault();
            const modal = e.target.parentElement;
            const startX = e.clientX;
            const startY = e.clientY;
            const startWidth = modal.offsetWidth;
            const startHeight = modal.offsetHeight;
            const onMove = (eMove) => {
              modal.style.width =
                startWidth + (eMove.clientX - startX) + "px";
              modal.style.height =
                startHeight + (eMove.clientY - startY) + "px";
            };
            const onUp = () => {
              window.removeEventListener("mousemove", onMove);
              window.removeEventListener("mouseup", onUp);
            };
            window.addEventListener("mousemove", onMove);
            window.addEventListener("mouseup", onUp);
          }}
        />
      </div>
    </div>
  );
}